import { h } from 'preact'

export default function Layout({
	children,
	header,
	facets,
	sideContent,
	bodyContent,
	footerContent,
}) {
	return (
		<main className="wsu-layout">
			{header && <div className="wsu-top">{header}</div>}

			<div className="wsu-middle">
				{sideContent && <aside className="wsu-side">{sideContent}</aside>}

				<div className="wsu-body">{children || bodyContent}</div>
			</div>

			{footerContent && <div className="wsu-footer">{footerContent}</div>}
		</main>
	)
}
